// import React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
// import { Stack, Chip } from '@mui/material';
import UserProductRegistraionForm from '../components/UserProductRegistrationForm';
import { Breadcrumbs, Link, Typography } from '@mui/material';

export default function UserProductRegistration() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const compId = queryParams.get('compId');
    const compName = queryParams.get('compName');

    // ✅ Get company type from query params
    let companyType = decodeURIComponent(queryParams.get('companytype') || "");
    
    // ✅ Normalize and default
    if (companyType !== "Ingredient Manufacturer" && companyType !== "Ingredient Distributor") {
        companyType = "Ingredient Manufacturer";
    }

    return (
        <Wrapper className='container'>
            <Breadcrumbs aria-label="breadcrumb" className='mb-5 mt-2 pageBreadCrumbs'>
                <Link underline="hover" color="inherit" href="/user-companies"> Companies </Link>
                <Link underline="hover" color="inherit" href={`/user-company-details?compId=${compId}`}> {compName} </Link>
                <Typography sx={{ color: 'text.primary' }}> Add product </Typography>
            </Breadcrumbs>

            <h2 className='pageTitle after_title_line'><span>Register your product</span></h2>
            <p className='statusBox'> Register Product for <strong> {compName} </strong> {companyType} </p>

            <UserProductRegistraionForm compId={compId} compName={compName} companyType={companyType} />
        </Wrapper>
    );
}

const Wrapper = styled.div`
.statusBox {
    background: var(--bg-color);
    border-left: 6px solid var(--secondary-color);
    padding: 4px 10px;
    color: var(--primary-color);
    margin-bottom: 20px;
}

.pageBreadCrumbs{
    a:hover {
        text-decoration: none;
        color: var(--secondary-color);
    }
}
`;
